import React, { FC } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import GlobalFooter from './GlobalFooter';
import './SettingsLayout.scss';
import SettingsSidebar from './SettingsSidebar';
import Navigation from './Navigation';

type LayoutProps = { children?: JSX.Element };

const SettingsLayout: FC<LayoutProps> = () => (
    <>
        <Navigation />

        <main role="main" className="page-container ">
            <SettingsSidebar>
                <Outlet />
            </SettingsSidebar>
        </main>
        <GlobalFooter />
        <ScrollRestoration />
    </>
);

export default SettingsLayout;
